import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import onMobile from 'helpers/onMobile'

const mapStateToProps = ({ notification, messages }) => {
  return {
    notification,
    generalError: messages && messages.generalError
  }
}

class Notification extends React.Component {
  render() {
    const { notification, generalError, classes } = this.props

    if ((!notification && !generalError) || !onMobile()) return null
    if (generalError && generalError.includes('locked')) return null

    return (
      <div className={classes.notification}>
        { notification ? notification.message : generalError }
      </div>
    )
  }
}

export default connect(mapStateToProps)(injectSheet(style)(Notification))



// WEBPACK FOOTER //
// ./src/components/Notification/index.js